import axios from "axios";
import {apiUri} from "../../../config";
import {push} from "connected-react-router";
import { NotificationManager } from 'react-notifications';

export const FETCH_SETTLEMENTRATES_ATTEMPT = 'FETCH_SETTLEMENTRATES_ATTEMPT';
export const FETCH_SETTLEMENTRATES_SUCCESS = 'FETCH_SETTLEMENTRATES_SUCCESS';
export const FETCH_SETTLEMENTRATES_FAILURE = 'FETCH_SETTLEMENTRATES_FAILURE';

export const CREATE_SETTLEMENTRATES_ATTEMPT = 'CREATE_SETTLEMENTRATES_ATTEMPT';
export const CREATE_SETTLEMENTRATES_SUCCESS = 'CREATE_SETTLEMENTRATES_SUCCESS';
export const CREATE_SETTLEMENTRATES_FAILURE = 'CREATE_SETTLEMENTRATES_FAILURE';

export const FETCH_SETTLEMENTRATE_ATTEMPT = 'FETCH_SETTLEMENTRATE_ATTEMPT';
export const FETCH_SETTLEMENTRATE_SUCCESS = 'FETCH_SETTLEMENTRATE_SUCCESS';
export const FETCH_SETTLEMENTRATE_FAILURE = 'FETCH_SETTLEMENTRATE_FAILURE';

export const SELECT_SETTLEMENTRATE = 'SELECT_SETTLEMENTRATE';

export const SETTLEMENTRATE_UPDATE = 'SETTLEMENTRATE_UPDATE';

global.loader = false;

export const fetch_settlementRates = (page) => {
	return (dispatch) => {
		dispatch({type: FETCH_SETTLEMENTRATES_ATTEMPT, page: page});
		axios.get(apiUri + "/SettlementRate?page=" + page)
			.then(json => {
				const response = json.data;
				dispatch({
					type: FETCH_SETTLEMENTRATES_SUCCESS,
					data: response.content,
					page: page,
					total_pages: response.totalPages
				})
			})
			.catch(err => {
				dispatch({type: FETCH_SETTLEMENTRATES_FAILURE, error: err})
			})
	}
};

export const select_settlementRate = (settlementRate_id) => {
	return (dispatch) => {
		dispatch({type: SELECT_SETTLEMENTRATE, id: settlementRate_id});
		dispatch(push("/SettlementRate/" + settlementRate_id));
	}
};

export const fetch_settlementRate = (settlementRate_id) => {
	return (dispatch) => {
		dispatch({type: FETCH_SETTLEMENTRATE_ATTEMPT, id: settlementRate_id});
		axios.get(apiUri + "/SettlementRate/" + settlementRate_id)
			.then(json => {
				dispatch({type: FETCH_SETTLEMENTRATE_SUCCESS, id: settlementRate_id, data: json.data})
			})
			.catch(err => {
				dispatch({type: FETCH_SETTLEMENTRATE_FAILURE, id: settlementRate_id, error: err})
			})
	}
};

export const updatePurchaseType = (id , Usertype,Type) => {
	var urlType = apiUri + "/SettlementRate/"+id;
	if(Type==='CUSTOM'){
		urlType = urlType+"_"+Type;      
	}
	 return (dispatch) => {
	   
		axios.put(urlType,'')
		.then(json => {
			global.loader = false;
			NotificationManager.success("Risk Assessment Saved Successfully");
		   dispatch(push("/SettlementRatesManagement"));

		})
		.catch(err => {
			console.log("Failed to create settlementRate " + err);
			global.loader = false;
			NotificationManager.error("Failed to create settlementRate" + err);
			dispatch({type: CREATE_SETTLEMENTRATES_FAILURE, error: err.response.data.message})
		})
	 }
};

export const create_settlementRate = (data,isSubscribe) => {
   
	//const pathname = window.location.pathname;
	
	 return (dispatch) => {
	   
		dispatch({type: CREATE_SETTLEMENTRATES_ATTEMPT});
		axios.post(apiUri + "/SettlementRate",data)
			.then(json => {
				dispatch({type: CREATE_SETTLEMENTRATES_SUCCESS, data: json});
				//dispatch(updatePurchaseType(json.data.data.id , isSubscribe ? 'SUBSCRIBER' : 'NONSUBSCRIBER',pathname.includes("/SettlementRatesManagement/create")&&'CUSTOM'))
				global.loader = false;
				NotificationManager.success("Risk Assessment Saved Successfully");
				dispatch(push("/SettlementRatesManagement"));
			})
			.catch(err => {     
				console.log("Failed to create settlementRate----> " + err);
				global.loader = false;
				NotificationManager.error("Failed to create settlementRate" + err);
				dispatch({type: CREATE_SETTLEMENTRATES_FAILURE, error: err.response.data.message})
			})
	 }
};


export const settlementRateUpdate = UpdateSettlementRateId => {
	return dispatch => {
			axios.get(apiUri + "/SettlementRate/"+ UpdateSettlementRateId)
			.then(json => {
				dispatch({type: SETTLEMENTRATE_UPDATE, 
					UpdateSettlementRateResult: json.data})
			})
			.catch(err => {
				console.log("Failed to create risk assessment " + err);
				dispatch({type: CREATE_SETTLEMENTRATES_FAILURE, error: err.response.data.message})
			})
	};
};


// WEBPACK FOOTER //
// ./src/components/SettlementRate/redux/actions.js